import Helpers from "@/services/helpers";
import { SET_VOLUME } from "@/store/mutation-types";
import { Howler } from "howler";

export default {
  name: "volume",
  install(ctx) {
    Helpers.mapStore(ctx, {
      volume: {
        get: "player/volume",
        set: `player/${SET_VOLUME}`
      }
    });

    const set = function(value) {
      const normalized = value / 100;
      const ease = normalized * normalized;

      Howler.volume(ease);

      this.volume = value;
    };

    return {
      set: set.bind(ctx)
    };
  }
};
